// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"658":"744c6cc9","741":"8cd832eb"}[chunkId] + ".chunk.js";
};